import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";
import { Link, withRouter } from "react-router-dom";
import AsyncAction from "../shared/AsyncAction";
import Currency from "../shared/Currency";
import InputNumber from "../shared/InputNumber";
import PageHeader from "../shared/PageHeader";
import { cartRemoveItem, cartUpdateQuantities } from "../../store/cart";
import { Cross12Svg } from "../../svg";
import { loadStripe } from "@stripe/stripe-js";
import { url } from "../../services/utils";
import theme from "../../data/theme";
import api from "../../api/api";
import { cartUpdateQuantitiesSuccess } from "../../store/cart";
import { toast } from "react-toastify";
import shopApi from "../../api/shop";
import { isRefreshTokenExpired } from "../../services/utils";
import { injectIntl } from "react-intl";
class ShopPageCart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantities: [],
        };
    }



    stripePromise = loadStripe(
        process.env.REACT_APP_STRIPE_KEY
    );
    

    componentDidUpdate(prevProps, prevState) {
        if (prevState.quantities !== this.state.quantities) {
            const { cartUpdateQuantities } = this.props;
            cartUpdateQuantities(this.state.quantities);
            cartUpdateQuantitiesSuccess(this.state.quantities);
        }
    }

    getItemQuantity(item) {
        const { quantities } = this.state;
        const quantity = quantities.find((x) => x.itemId === item.product.id);
        return quantity ? quantity.value : item.quantity;
    }

    handleChangeQuantity = (item, quantity) => {
        this.setState((state) => {
            const quantities = [...state.quantities];
            const stateQuantity = quantities.find((x) => x.itemId === item.product.id);   

            if (!stateQuantity) {
                quantities.push({ itemId: item.product.id, value: quantity });
            } else {
                stateQuantity.value = quantity;
            }
            return { quantities };
        });
    };

    renderTotal() {
        const { cart } = this.props;        
        const total = cart.items.reduce((sum, item) => sum + item.total, 0);        

        return (
            <tr className="cart-table__row cart-table__row--total border p-2">
                <td colSpan="4" className="text-right pr-3 cart-table__column--total--lg"><strong><FormattedMessage id="Cart.subtotal" defaultMessage="Subtotal" /></strong></td>
                <td className="cart-table__column cart-table__column--total" data-title={this.props.intl.formatMessage({ id: 'Cart.subtotal', defaultMessage: 'Subtotal' })}>
                    <Currency value={total} />
                </td>
            </tr>
        );
    }

    renderItems() {
        const { cart, cartRemoveItem } = this.props;
        return cart.items.map((item) => {
            let image;
            let options;

            if (item.product.images.length > 0) {
                image = (
                    <div className="product-image">
                        <Link to={url.product(item.product)} className="product-image__body">
                            <img className="product-image__img" src={item.product.images[0]} alt="" />
                        </Link>
                    </div>
                );
            }

            if (item.options.length > 0) {
                options = (
                    <ul className="cart-table__options">
                        {item.options.map((option, index) => (
                            <li key={index}>{`${option.optionTitle}: ${option.valueTitle}`}</li>
                        ))}
                    </ul>
                );
            }

            const removeButton = (
                <AsyncAction
                    action={() => cartRemoveItem(item.product._id || item.product.id)}
                    render={({ run, loading }) => {
                        const classes = classNames("btn btn-light btn-sm btn-svg-icon", {
                            "btn-loading": loading,
                        });

                        const { user } = this.props;

                        console.log(user, "user");

                        return (
                            <button type="button" onClick={run} className={classes}>
                                <Cross12Svg />
                            </button>
                        );
                    }}
                />
            );

            return (
                <>
                    <tr key={item.id} className="cart-table__row">
                        <td className="cart-table__column cart-table__column--image">{image}</td>
                        <td className="cart-table__column cart-table__column--product">
                            <Link to={url.product(item.product)} className="cart-table__product-name">
                                {item.product.name}
                            </Link>
                            {options}
                        </td>
                        <td className="cart-table__column cart-table__column--price" data-title={this.props.intl.formatMessage({ id: 'Cart.price', defaultMessage: 'Price' })}>
                            <Currency value={item.price} />
                        </td>
                        <td className="cart-table__column cart-table__column--quantity" data-title={this.props.intl.formatMessage({ id: 'Cart.quantity', defaultMessage: 'Quantity' })}>
                            <InputNumber
                                onChange={(quantity) => this.handleChangeQuantity(item, quantity)}
                                value={this.getItemQuantity(item)}
                                min={1}
                            />
                        </td>
                        <td className="cart-table__column cart-table__column--total" data-title={this.props.intl.formatMessage({ id: 'Cart.total', defaultMessage: 'Total' })}>
                            <Currency value={item.total} />
                        </td>
                        <td className="cart-table__column cart-table__column--remove">{removeButton}</td>
                    </tr>
                </>
            );
        });
    }

    renderTotals() {
        const { cart } = this.props;


        if (cart.extraLines.length <= 0) {
            return null;
        }

        return (
            <tr>
                <td>
                    <Currency value={cart.subtotal} />
                </td>
            </tr>
        );
    }



    handleLogout = (refreshToken) => {
        shopApi.logout(refreshToken);
        this.props.history.push('/');
        // dispatch(clearWishlist());
    };


    handlePlaceOrder = async (event) => {
        event.preventDefault();

        const { cart, user } = this.props;
        const token = user?.refreshToken;

        if (isRefreshTokenExpired(token)) {

            toast.error(
                <div>
                    <p>Votre session a expiré. Veuillez vous reconnecter.</p>
                    <button
                        onClick={() => {
                            toast.dismiss(); // Fermer le toast
                            this.handleLogout(token);
                        }}
                        style={{
                            backgroundColor: "#fff",
                            color: "#d32f2f",
                            border: "1px solid #d32f2f",
                            padding: "5px 10px",
                            cursor: "pointer",
                            borderRadius: "5px",
                            marginTop: "5px"
                        }}
                    >
                        OK
                    </button>
                </div>,
                { theme: "colored", autoClose: false } // Désactiver la fermeture automatique
            );

            return;
        }

        try {
            const response = await api.post("payment/create-checkout-session", {
                firstName: user?.firstName || "Anonymous",
                lastName: user?.lastName || "Anonymous",
                phone: user?.phone,
                email: user?.email,
                user: user?.id,
                items: cart.items.map((item) => ({
                    name: item.product.name,
                    amount: item.price,
                    currency: "cad",
                    quantity: item.quantity,
                    productId: item.product.id || item.product._id,
                })),
            })
            if (response.data.requestedQuantity) {
                toast.error(
                    <div>
                        <p> <FormattedMessage id="shopPageCart.errorQuantity" values={{ product: response.data.productName, quantity: response.data.availableStock }} /></p>
                        <button
                            onClick={() => {
                                toast.dismiss(); // Fermer le toast
                            }}
                            style={{
                                backgroundColor: "#fff",
                                color: "#d32f2f",
                                border: "1px solid #d32f2f",
                                padding: "5px 10px",
                                cursor: "pointer",
                                borderRadius: "5px",
                                marginTop: "5px"
                            }}
                        >
                            OK
                        </button>
                    </div>,
                    { theme: "colored", autoClose: false } // Désactiver la fermeture automatique
                );

                return;
            };


            const { id: sessionId } = response.data;

            const stripe = await this.stripePromise;

            const { error } = await stripe.redirectToCheckout({ sessionId });

            if (error) {
                console.error({ errorMessage: error.message });
            }
        } catch (error) {
            console.error({ errorMessage: error.message });
        }
    };

    renderCart() {
        return (
            <div className="cart block">
                <div className="container">
                    <table className="cart__table cart-table">
                        <thead className="cart-table__head">
                            <tr className="cart-table__row">
                                <th className="cart-table__column cart-table__column--image"><FormattedMessage id="header.shoppingCart" defaultMessage="Cart" /></th>
                                <th className="cart-table__column cart-table__column--product"><FormattedMessage id="Cart.product" defaultMessage="Product" /></th>
                                <th className="cart-table__column cart-table__column--price"><FormattedMessage id="Cart.price" defaultMessage="Price" /></th>
                                <th className="cart-table__column cart-table__column--quantity"><FormattedMessage id="Cart.quantity" defaultMessage="Quantity" /></th>
                                <th className="cart-table__column cart-table__column--total"><FormattedMessage id="Cart.total" defaultMessage="Total" /></th>
                                <th className="cart-table__column cart-table__column--remove" aria-label="Remove" />
                            </tr>
                        </thead>
                        <tbody className="cart-table__body">{this.renderItems()} {this.renderTotal()}</tbody>
                    </table>
                    <div className="cart__actions justify-content-end">
                        {/* <form className="cart__coupon-form">
                            <label htmlFor="input-coupon-code" className="sr-only">Password</label>
                            <input type="text" className="form-control" id="input-coupon-code" placeholder="Coupon Code" />
                            <button type="submit" className="btn btn-primary">Apply Coupon</button>
                        </form> */}
                        <div className="cart__buttons">
                            <button onClick={this.handlePlaceOrder} className="btn btn-primary btn-xl ">
                                <FormattedMessage id="Cart.proceedToCheckout" defaultMessage="Proceed to checkout" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { cart } = this.props;
        const breadcrumb = [
            { title: <FormattedMessage id="header.home" defaultMessage="Home" />, url: "" },
            { title: <FormattedMessage id="header.shoppingCart" defaultMessage="Shopping Cart" />, url: "" },
        ];

        let content;

        if (cart.quantity) {
            content = this.renderCart();
        } else {
            content = (
                <div className="block block-empty">
                    <div className="container">
                        <div className="block-empty__body">
                            <div className="block-empty__message"><FormattedMessage id="Cart.empty" defaultMessage="Your shopping cart is empty!" /></div>
                            <div className="block-empty__actions">
                                <Link to="/" className="btn btn-primary btn-sm">
                                    <FormattedMessage id="Cart.continueShopping" defaultMessage="Continue Shopping" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <React.Fragment>
                <Helmet>
                    <title>{`Shopping Cart — ${theme.name}`}</title>
                </Helmet>

                <PageHeader header={<FormattedMessage id="header.shoppingCart" defaultMessage="Cart" />} breadcrumb={breadcrumb} />

                {content}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    cart: state.cart,
    user: state.user.userConnected.user,
});

const mapDispatchToProps = {
    cartRemoveItem,
    cartUpdateQuantities,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(ShopPageCart)));
